var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.82422H9C7.9 2.82422 7 3.72422 7 4.82422V16.8242C7 17.9242 7.9 18.8242 9 18.8242H18C19.1 18.8242 20 17.9242 20 16.8242V4.82422C20 3.72422 19.1 2.82422 18 2.82422ZM18 16.8242H9V4.82422H18V16.8242ZM3 15.8242V13.8242H5V15.8242H3ZM3 10.3242H5V12.3242H3V10.3242ZM10 20.8242H12V22.8242H10V20.8242ZM3 19.3242V17.3242H5V19.3242H3ZM5 22.8242C3.9 22.8242 3 21.9242 3 20.8242H5V22.8242ZM8.5 22.8242H6.5V20.8242H8.5V22.8242ZM13.5 22.8242V20.8242H15.5C15.5 21.9242 14.6 22.8242 13.5 22.8242ZM5 6.82422V8.82422H3C3 7.72422 3.9 6.82422 5 6.82422Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.8dc1e6c89a40278ad9075786724f049c.svg";
export { ForwardRef as ReactComponent };